
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import {$util} from "@util/util.js";
export default class OptionListWapView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        // console.log('初始数据',this._model);

        this._parentEl = this._model._parent._view._optionBoxEl;
        this._el = null;
    }
    initData() {
      this._model._optionList.map((items,i)=>{
          items.optionnum = 1
      })
      if(this._model._parent._option){
        this._model._parent._option._data.map((item,index)=>{
          this._model._optionList.map((items,i)=>{
            if(item.id == items.code) {
              items.optionStatus = true;
              items.optionnum = item.num;
            }
          })
        })
      }
      // console.log('处理数据之后的选件',this._model);

    }
    getMaxBtnDisabled(item){
      if(item._count>=item.stockNum){
          return "disabled";
      }
      return "";
  }
    getCount() {
      var num = 0;
      $('.option_wrapper .item .icon-checked').each((index,item)=> {
        let arrNum = 0, optionNum = $(item).attr("data-num"),status = $(item).attr("status");
        // num += Number($(item).parent().parent().find("[tag='optionCount']").val())
        if(status == "1"){
          if($(item).parent().parent().find('.item_right .le_num_action input:nth-child(2)').val()>1) {
            num += Number($(item).parent().parent().find('.item_right .le_num_action input:nth-child(2)').val());
          } else if($(item).parent().parent().find('.item_right .le_num_action input:nth-child(2)').val() == 1) {
            num += 1;
          }
        }else{
          num += Number(optionNum);
        }
      })
      return num;

    }
    itemStyle(item){
      if(item.optionnum == 1){
        return 'color:#E0E0E0;pointer-events: none;'
      }
      return ''
    }
    // || item.optionnum >= this._model._parent._maxPurchase
    itemStyleAdd(item){
      if(item.optionnum >= item.limitedNumber ||  item.optionnum >= item.stockNum  || item.optionnum >= this._model._parent._count){
        return 'color:#E0E0E0;pointer-events: none;'
      }
      return ''
    }
    itemTitleStork(item){
      if(item.stockNum &&item.limitedNumber){
        if(item.limitedNumber<item.stockNum && item.limitedNumber < this._model._parent._count){
          return `<i style="color:#FF2F2F;font-style:normal;position:absolute;left:0.24rem;bottom:-0.2rem;;font-size:12px;">限购${item.limitedNumber}件</i>`
        }else if(item.stockNum  < this._model._parent._count){
          return `<i style="color:#FF2F2F;font-style:normal;position:absolute;left:0.24rem;bottom:-0.2rem;;font-size:12px;">库存${item.stockNum}件</i>`
        }
      }
      if(item.stockNum  < this._model._parent._count){
        return `<i style="color:#FF2F2F;font-style:normal;position:absolute;left:0.24rem;bottom:-0.2rem;;font-size:12px;">库存${item.stockNum}件</i>`
      }
      if(item.limitedNumber < this._model._parent._count){
        return `<i style="color:#FF2F2F;font-style:normal;position:absolute;left:0.24rem;bottom:-0.2rem;;font-size:12px;">限购${item.limitedNumber}件</i>`
      }
     
      return ''
    }
    itemCOunt(item){
      if (!item.status){
        return '';
      }else{
        return `<p class="le_num_action">
          <input type="button" style="${this.itemStyle(item)}" tag="optionCount" value="-" class="reduce" />
          <input class="num" readonly value="${item.optionnum}" type="text"  />
          
          <input type="button"  style="${this.itemStyleAdd(item)}" data-limitedNumber="${item.limitedNumber}" data-stockNum="${item.stockNum}"  value="+" class="add" />
          ${this.itemTitleStork(item)}
        </p>` 
      }
    }
    getItems(category){
        let html = ''
        this._model._optionList.map((item,index) => {
          // console.log('选件item',item);
            html += ` <div class="item ${item.status ? '' : 'disable'} jumpDetail">
            <div class="i_checkbox">
              <i data-code="${item.code}" data-num="${item.optionnum}" class="iconfont ${item.optionStatus ? 'icon-checked' : item.status ? 'icon-uncheck' : 'icon-disabled'} item_checkbox" style="pointer-events:'${item.status?'none':'none'}'" status=${item.status} ></i>
            </div>
            <a href="${item.goodsDetailUrl}">
            <div class="i_img">
              <img src="${item.path}" alt="">
              <div class="already_sold_box"></div>
            </div>
            </a>
            <div class="item_right">
            <a href="${item.goodsDetailUrl}">
              <h3 class="good_name">${item.goodsName}</h3>
              </a>
              <div class="price_num">
              <a href="${item.goodsDetailUrl}">
                <div class="i_price">`;
                // 失效状态一般包括下架和没库存, 所以这里只判断status为0的时候就好
                  // if(!item.status && item.stockNum == 0) {
                  //   html+=`<div class="price_disable">已赠完</div>`;
                  // } else if (!item.status && item.stockNum > 0) {
                  //   html+=`<div class="price_disable">已失效</div>`;
                  // } else {
                  //   html+=`<div class="price_able" style="display:${item.status ? 'block;' : 'none;'}"><p><span>¥</span>${item.productPrice}<span></span></p><p class="reduce_price le_tip_btn_border">省${item.discountAmount}元</p></div>`;
                  // }
                  if (!item.status){
                    html+=`<div class="price_disable">已失效</div>`;
                  } else {
                    html+=`<div class="price_able" style="display:${item.status ? 'block;' : 'none;'}"><p><span>¥</span>${item.productPrice}<span></span></p><p class="reduce_price le_tip_btn_border">省${item.discountAmount}元</p></div>`;
                  }
                  
                html+= `</div>
                </a>
                  ${this.itemCOunt(item)}
                
              </div>
              
            </div>

          </div>`;
        })

      return html
    }


    render(){
      this.initData();
        let html = "";
        html += `${this.getItems()}`;
        $(this._parentEl.find("div.option_common_content")).html($(html));
        // $(this._parentEl.find("img.service_goods_img")).attr("src",this._model._parent._data.imgUrl);
        this._el = $(".option_wrapper");
        // 每次render都清空选择了几件服务
        $('.option_wrapper .option_common_bottom p span').html('0');
        //每次渲染页面的时候就把选择了几个选件渲染到页面
        $('.option_wrapper .option_common_bottom p span').html(`${this.getCount()}`);
        this.regEvent();
    }
    regEvent() {
        let that = this;
        // 点击选择服务叉号, 隐藏弹窗icon-close
        this._el.off("click", ".icon-close").on("click", ".icon-close", function () {
            $(".option_wrapper").hide();
            $util.toggleBodyScroller(false);
        })
        // 点击checkbox改变效果
        this._el.off("click", ".option_common_content .i_checkbox i").on("click", ".option_common_content .i_checkbox i", function () {
          let status = $(this).attr('status')
          if(status == 0){
            $(this).removeClass('icon-checked').addClass('icon-disabled');
          }else{
            if($(this).hasClass('icon-uncheck')) {
              $(this).removeClass('icon-uncheck').addClass('icon-checked');
            } else if($(this).hasClass('icon-checked')) {
              $(this).removeClass('icon-checked').addClass('icon-uncheck');
            }
          }
          //每次渲染页面的时候就把选择了几个选件渲染到页面
          $('.option_wrapper .option_common_bottom p span').html(`${that.getCount()}`);

      })
      // 点击加
      this._el.off("click", ".le_num_action .add").on("click", ".le_num_action .add", function () {
          let stockNum = $(this).attr('data-stockNum');
          let limitedNumber = $(this).attr('data-limitedNumber');
          let count = $(this).siblings('.num').val();
           count++;
           $(this).siblings('.reduce').css('pointer-events','auto');
          if(count == stockNum) {
            // 当前到最大库存
            $(this).css('color','#E0E0E0');
            $(this).css('pointer-events','none');
            // $(this).siblings('i').html('库存' + count +'件').show();
          } else if(count == that._model._parent._count) {
            // 当前到主品最大数量
            $(this).css('color','#E0E0E0');
            $(this).css('pointer-events','none');
            // $(this).siblings('i').html('限购' + count+'件').show();
          } else if(count == that._model._parent._maxPurchase) {
            // 当前到限购最大数量
            $(this).css('color','#E0E0E0');
            $(this).css('pointer-events','none');
            // $(this).siblings('i').html('限购' + count + '件').show();
          }
          else if(count == limitedNumber) {
            // 当前到限购最大数量
            $(this).css('color','#E0E0E0');
            $(this).css('pointer-events','none');
            $(this).siblings('i').html('限购' + limitedNumber + '件').show();
          }
          else {
            //每次渲染页面的时候就把选择了几个选件渲染到页面
          }
          $(this).siblings('.num').val(count);
          $('.option_wrapper .option_common_bottom p span').html(`${that.getCount()}`);
          if(count > 1) {
            $(this).siblings('.reduce').css('color','#454545');
          }
      })
      // 点击减
      this._el.off("click", ".le_num_action .reduce").on("click", ".le_num_action .reduce", function () {
        // 每次点减号就让加号可以点击
        
        let count = $(this).siblings('.num').val();
        count--;
        if(count == 1) {
          $(this).css('color','#E0E0E0');
          count = 1;
          $(this).siblings('.num').val(count);
          $(this).siblings('.add').css('pointer-events','auto');
          $(this).siblings('.add').css('color','#454545');
          //每次渲染页面的时候就把选择了几个选件渲染到页面
          $('.option_wrapper .option_common_bottom p span').html(`${that.getCount()}`);
        } else if(count > 1) {
          $(this).siblings('.add').css('color','#454545');
          $(this).siblings('.add').css('pointer-events','auto');
          $(this).siblings('i').hide();
          $(this).css('color','#454545');
          $(this).siblings('.num').val(count);
          //每次渲染页面的时候就把选择了几个选件渲染到页面
          $('.option_wrapper .option_common_bottom p span').html(`${that.getCount()}`);
        }
        
      })
      // 点击确定
      this._el.off("click", ".option_common_box .option_common_bottom button").on("click", ".option_common_box .option_common_bottom button", function () {
        var isflag = 1;
        // 判断是否选择了失效商品
        $('.option_wrapper .option_common_content .i_checkbox i.icon-checked').parent().parent().each((index,item)=> {
          // console.log('111111',$(item).hasClass('disable'));
          if($(item).hasClass('disable')) {
            isflag = 0;
            Alert.showTip('请取消失效商品');
            // 包含失效商品
            return false;
          }
        })
        if(isflag == 1) {
          var box = [];
          $('.option_wrapper .option_common_content .i_checkbox i.icon-checked').each((index,item)=> {
            let list = {};
            list.gcode=$(item).attr('data-code');
            list.num=$(item).parent().siblings('.item_right').children('.price_num').children('.le_num_action').children('.num').val();
            box.push(list);
          })
          that._model._parent.modifyItemFromCart({opsType:1,content:JSON.stringify(box)}).then(()=>{
            // 判断如果是0的话就手动隐藏服务的样式
            // 解决问题是: 不选择服务, 不会更新样式,始终保持着最后一条更新的服务, 刷新页面就会更新
            if(box.length == '0') {
              $(that._model._parent._view._extraBoxEl.find('div.option')).hide();
            }
            $(".option_wrapper").hide();
            $util.toggleBodyScroller(false);
          }).catch(err =>{
            Alert.showTip(err);
          });
          
        }
    })
    }
}

